const UPDATE_KYB_MUTATION = `mutation UpdateKybMutation(
  $kybId: ID!,
  $rawKybPhoneNumber: String!,
  ) {
  vaultKybUpdate(
    id: $kybId,
    phoneNumber: $rawKybPhoneNumber,
  )
}`;

export const requestBodyFormatter =
  ({ kybId }: { kybId: string }) =>
  (formValues: Record<string, string>): VgsRequestBody => ({
    query: UPDATE_KYB_MUTATION,
    variables: {
      kybId,
      rawKybPhoneNumber: formValues.kybPhoneNumber,
    },
  });
